// Deterministic, unique-per-entity SEO intro copy generators.
// Avoids duplicate-content penalties by varying phrasing based on a stable hash.

function hash(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) & 0xffffffff;
  return Math.abs(h);
}
const pick = (arr, seed) => arr[seed % arr.length];

export function schoolIntro(s) {
  const seed = hash(s.id || s.slug || s.name);
  const mascot = s.mascot || "students";
  const city = s.city || "your town";
  const county = s.county ? `${s.county} County` : "Wisconsin";
  const openers = [
    `Every ${mascot} deserves a look that turns heads in ${city}.`,
    `Prom season in ${city} hits different when you're a ${mascot}.`,
    `${s.name} students shop Heather's for the dress no one else will have.`,
    `For the ${mascot} of ${s.name}, formalwear is a statement — not a checkbox.`,
  ];
  const middles = [
    `Our ${city} collection blends editorial silhouettes with the one-per-school dress lock, so your gown or tux is truly yours across ${county}.`,
    `Browse curated prom, homecoming and graduation looks tuned for ${s.name}, then lock yours before another ${mascot} can.`,
    `From blush satin columns to tailored onyx tuxedos, we style ${s.name} for prom, homecoming and graduation night.`,
    `Lock your look, plan your squad's colors, and try it on virtually — all reserved for the ${mascot} community.`,
  ];
  const closers = [
    `Register with your ${s.name} email to unlock the full experience.`,
    `Verify your school email and step into your school's private atelier.`,
    `Your school portal, squads and memory hub are one email away.`,
  ];
  return `${pick(openers, seed)} ${pick(middles, seed >> 2)} ${pick(closers, seed >> 4)}`;
}

export function cityIntro(name, county, count) {
  const seed = hash(name);
  const openers = [
    `Prom dresses in ${name}, Wisconsin have never felt this personal.`,
    `Shopping for a ${name} prom or homecoming look? Start here.`,
    `${name}'s formalwear destination for prom, graduation and homecoming.`,
  ];
  const middles = [
    `Heather's Boutique serves ${count} ${count === 1 ? "school" : "schools"} in and around ${name} (${county} County) with school-exclusive collections and our signature 2-hour dress lock.`,
    `We dress ${name} students across ${count} ${count === 1 ? "school" : "schools"} — luxury gowns, tailored tuxedos, and accessories, reserved one-per-school so you never match.`,
    `From ${county} County classrooms to the dance floor, ${name} students find editorial looks, AI fit guidance and virtual try-on right here.`,
  ];
  return `${pick(openers, seed)} ${pick(middles, seed >> 3)}`;
}

export function countyIntro(name, count, students) {
  const seed = hash(name);
  const openers = [
    `${name} County is home to ${count} high schools on the Wisconsin Prom Network.`,
    `Serving ${count} ${name} County schools and ${students.toLocaleString()} students.`,
    `Prom, homecoming and graduation formalwear across ${name} County.`,
  ];
  const middles = [
    `Find your school below to unlock its exclusive collection, per-school dress locks, squad planning and memory hub.`,
    `Each school gets its own private atelier — lock your look so no two students at your school arrive in the same dress.`,
    `Shop editorial gowns and tailored tuxedos, then reserve yours before anyone else in ${name} County.`,
  ];
  return `${pick(openers, seed)} ${pick(middles, seed >> 3)}`;
}
